import template from './sw-cms-block-image-slider.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
